export default {
  methods: {
    // search-mixin 写了这些函数

    //   handleImport() {
    //     this.$refs.refImportDialog.show();
    //   },
    //   async handleFile(file) {
    //     // console.log("file", file);
    //     let form = new FormData();
    //     form.append("file", file);
    //     // form.append("test", "test");
    //     console.log("form", form);
    //     let { data, err } = await this.axiosApi(this.Desc.import_api, form);
    //   },
  },
}


// WEBPACK FOOTER //
// ./src/common/mixins/handle-import/index.js